module.exports = __webpack_public_path__ + "static/media/header-logo.dee9c94d.png";